module.exports = __webpack_public_path__ + "5d5bff99a78d74502b29774650b2e6b5.MP3";